import Fetch from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_POST_RESPONSE } from '@config/constanta';
import {
  stockOrderUrl,
  stockBonusOrderUrl,
  stockAutoOrderUrl,
  stockAutoOrderByIdUrl,
} from './_endpoint';

const fetchPost = (resourceUrl, payload) =>
  Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

const fetchPut = (resourceUrl, payload) =>
  Fetch.put(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_POST_RESPONSE, err_message: error.message };
    });

// Regular Limit order
export const postStockBuy = (payload = {}) => fetchPost(stockOrderUrl('buy'), payload);
export const postStockSell = (payload = {}) => fetchPost(stockOrderUrl('sell'), payload);
export const postStockAmend = (payload = {}) => fetchPost(stockOrderUrl('amend'), payload);
export const postStockWithdraw = (payload = {}) => fetchPost(stockOrderUrl('withdraw'), payload);

// Regular Auto order
export const postStockAutoOrder = (payload = {}) => fetchPost(stockAutoOrderUrl('REG'), payload);
export const putStockAutoOrderAmend = (order_id, payload = {}) =>
  fetchPut(stockAutoOrderByIdUrl('', order_id), payload);
export const putStockAutoOrderDeactivate = (order_id, payload = {}) =>
  fetchPut(stockAutoOrderByIdUrl('pause/', order_id), payload);
export const putStockAutoOrderReactivate = (order_id, payload = {}) =>
  fetchPut(stockAutoOrderByIdUrl('resume/', order_id), payload);
export const putStockAutoOrderCancel = (order_id, payload = {}) =>
  fetchPut(stockAutoOrderByIdUrl('cancel/', order_id), payload);

// Stock Referral Bonus
export const postStockBonusSell = (payload = {}) => fetchPost(stockBonusOrderUrl('sell'), payload);
export const postStockBonusAmend = (payload = {}) =>
  fetchPost(stockBonusOrderUrl('amend'), payload);
